import { countryConfig, provinceConfig } from './cantonConfig';
import { commonMenu } from './commonMenu';

const config = {
    language: 'en',
    languages: ['en', 'de', 'fr', 'it'],
    provinces: provinceConfig,
    countries: countryConfig,
    defaultSort: {
        field: 'id',
        direction: null
    },
    systemRoles: ['ecoo', 'partner', 'merchant', 'user', 'sme_admin'],
    allowMerchantRegistration: true,
    allowGoogleAuth: true,
    allowTwoFactorAuth: ['ecoo', 'partner'],
    chartSettings: {
        hiddenFields: []
    },
    hiddenColumns: null, // { nameTable: ['idColumn'] }
    menu: commonMenu,
    currenciesCodes: ['CHF', 'EUR', 'USD']
};

export default config;
